import { isUUID, UUID } from '@nova/types';

export const AI_BOT_ID: UUID = '00000000-0000-0000-0000-000000000000' as UUID;
if (!isUUID(AI_BOT_ID)) {
  throw new Error(`Invalid AI_BOT_ID: ${AI_BOT_ID}`);
}
